export default {
  "sidebar.setting": { en: "Setting", fa: "تنظیمات" },
  "sidebar.network-config": {
    en: "Network Config",
    fa: "تنظیمات شبکه"
  },
  "sidebar.category": {
    en: "Category",
    fa: "دسته‌ بندی"
  },
  "sidebar.categories": { en: "Categories", fa: "دسته ‌بندی‌ها" },
  "sidebar.category-properties": {
    en: "Category Property",
    fa: "خصوصیات دسته‌ بندی‌ها"
  },
  "sidebar.product": { en: "Product", fa: "محصول" },
  "sidebar.products": { en: "Products", fa: "محصول‌ها" },
  "sidebar.product-prices": {
    en: "Product Prices",
    fa: "مدیریت قیمت محصول‌ها"
  },
  "sidebar.product-warehouses": {
    en: "Product Warehouse",
    fa: "مدیریت موجودی محصول‌ها"
  },
  "sidebar.warehouse-transactions": {
    en: "Warehouse Transactions",
    fa: "مدیریت معامله‌ها"
  },
  "sidebar.commercial-report": {
    en: "Commercial Report",
    fa: "گزارش تبلیغات"
  },
  "sidebar.invoices": {
    en: "Invoices",
    fa: "صورت حساب‌ها"
  }
};
